import { all } from 'redux-saga/effects'

import { coreSagas } from 'app/core/coreSaga'
import { pendingTasksEffects } from 'app/core/pendingTasksSaga'
import { viewingDetailsEffects } from 'app/pages/Viewings/MobileViewings/ViewingDetails/sagas'

export default function* rootSaga() {
  yield all([viewingDetailsEffects(), pendingTasksEffects(), ...coreSagas])
}
